import { imgSrc } from "@/lib/api";

export const VideoEmbed = ({ video, testId }) => {
  if (!video) return null;
  if (video.kind === "file") {
    return (
      <video controls playsInline preload="metadata" src={imgSrc(video.url)} data-testid={testId}
        className="w-full max-h-[520px] rounded-xl bg-black mt-4" />
    );
  }
  const src = video.kind === "vimeo"
    ? `https://player.vimeo.com/video/${video.id}${video.hash ? `?h=${video.hash}` : ""}`
    : `https://www.youtube-nocookie.com/embed/${video.id}?rel=0&modestbranding=1`;
  return (
    <div className="aspect-video rounded-xl overflow-hidden bg-black mt-4" data-testid={testId}>
      <iframe className="w-full h-full" src={src} title="Video" allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" />
    </div>
  );
};
